import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { moneyFormat, parseStringOr } from '../../helpers/AppxUtils';
import { TvPlanContext } from '../../contexts/tvplancontext';
import TvService from '../TvService';

import tvImg from '../../tv.png';
import netImg from '../../net.png';
import voiceImg from '../../voice.png';

import './index.css';


export default function TvPlanStarter() {
    const { t, i18n } = useTranslation('tvplan');
    const ctx = useContext(TvPlanContext);
    const plan = ctx.getStarterPlan() || {};
    let des = parseStringOr(plan.des, "");
    let desFr = parseStringOr(plan.desFr, "");

    if (i18n.language === "fr" && desFr !== "") {
        des = desFr;
    }

    let planStartData = plan.data || {};
    let startServices = {}

    if (Array.isArray(planStartData?.services)) {
        for (let s of planStartData.services) {
            startServices[s] = true;
        }
    }

    startServices = Object.keys(startServices);

    return (
        <div className="tv-plan-plan tv-plan-starter" data-apiCode={plan.apiCode}>
            <div className="tv-plan-price">
                {t('TvPlanStep1.selected_price', {
                    price: moneyFormat(plan.monthlyPrice, plan.currency),
                })}
            </div>
            <div className="tv-plan-name">
                <div className="tv-plan-icons">
                    {plan.isNet > 0 && (<img src={netImg} alt="net-icon" />)}
                    {plan.isVoice > 0 && (<img src={voiceImg} alt="voice-icon" />)}
                    {plan.isTv > 0 && (<img src={tvImg} alt="tv-icon" />)}
                </div>
                {des}
            </div>
            <div className="tv-plan-services">
                {startServices.map((s, idx) => (
                <TvService
                    key={`key-${ctx.startPlan}-${s}-${idx}`}
                    showPlus={false}
                    showSelected={false}
                    code={s}
                />
                ))}
            </div>
        </div>
    );
}
